import React, { useState } from 'react'
import SeactionHeader from '../seactionheader/SeactionHeader'
import { ImQuotesLeft } from "react-icons/im";
import Card from '../../ui/Card';
import { testimonials } from "../../data";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

function Testmonial() {

    const [index, setindex] = useState(0)
    const {name, quote, job, avatar} = testimonials[index];

    const prevTestmonialHandel = () => {
        setindex(prev => prev -  1);

        if(index < 0){
            setindex(testimonials.length - 1);
        }

    }

    const NextTestmonialHandel = () => {
        setindex(prev => prev + 1);

        if(index >= testimonials.length - 1){
            setindex(0)
        }
    }


  return (
    <section className='testmonials'>
        <div className="container container__Testmonial">
            <SeactionHeader icon={<ImQuotesLeft />} title="testmonial" className="testmonials__head"/>
            <Card className='testmonial'>
                <div className="testmonial__avatar">
                    <img src={avatar} alt={name} />
                </div>
                <p className='testmonial__quote'>
                    {`${quote}`}
                </p>
                <h5>{name}</h5>
                <small className='testmonial__title'>{job}</small>
            </Card>

            <div className="testmonials__btn-container">
                <button className="testmonials__btn" onClick={prevTestmonialHandel}>
                    <IoIosArrowBack />
                </button>
                <button className="testmonials__btn" onClick={NextTestmonialHandel}>
                    <IoIosArrowForward />
                </button>
            </div>
        </div>
    </section>
  )
}

export default Testmonial